import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonFrom from "../../../Common/Components/Form";
import Loading from "../../../Common/Components/Loading";
import { editprofile, GetData } from "./Components/Services";
import Password from "./Password";

function Edite({ isApp }) {
  const initialState = {
    loading: true,
    rerender: false,
  };

  const dispatch = useDispatch();
  const { user } = useSelector(state => state);
  const [state, setstate] = useState(initialState);

  useEffect(() => {
    getdata();
  }, []);

  const load = (data = null) => {
    setstate({ ...state, rerender: true });
  };

  const getdata = (data = null) => {
    setstate({ ...state, loading: true });
    GetData(data).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  let input = [
    {
      label: "نام و نام خانوادگی",
      size: "col-md-4",
      classNames: "mt-2",
      placeholder: "",
      name: "fullname",
      type: "text",
    },
    {
      label: "جنسیت",
      size: "col-md-4",
      classNames: "mt-2",
      placeholder: "",
      name: "gender",
      input: "select",

      options: [
        {
          id: "man",
          name: "آقا",
        },
        {
          id: "woman",
          name: "خانم",
        },
      ],
    },
    {
      label: "ایمیل",
      size: "col-md-4",
      classNames: "mt-2",
      placeholder: "",
      name: "email",
      type: "text",
    },

    {
      label: "کد ملی",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "national_code",
      type: "number",
    },
    {
      label: "شماره تلفن همراه",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "mobile",
      type: "number",
      disabled: true,
    },
    {
      label: "درباره من",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "meta_data",
      keyname: "bio",
      input: "textarea",
    },
    {
      label: "تصویر پروفایل",
      size: "col-md-4",
      classNames: "mt-2",
      name: "profile",
      input: "file",
      accept: "image/png, image/jpeg",
    },
  ];

  const Handler = data => {
    setstate({ loading: true });
    editprofile(data).then(result => {
      dispatch({
        local_storage: {
          key: "user",
          value: { ...user, ...result },
        },
        type: "SET",
        payload: { user: { ...user, ...result } },
      });
      getdata();
    });
  };

  return (
    <Fragment>
      {state.loading ? (
        <>
          {isApp
            ? <Loading count={4} col={12} height={30} />
            : <Loading count={1} col={12} height={400} />
          }
        </>
      ) : (
        <div style={{ marginBottom: "20px" }} className="col-12">
          <CommonFrom
            form={input}
            loading={false}
            header={isApp ? null : "ویرایش پروفایل"}
            shadowClass={!isApp ? null : "shadow-none mt-4 appInputBox"}
            btnName="ثبت اطلاعات"
            submit={Handler}
            value={state.data}
            edit={true}
            isApp={isApp}
          />
        </div>
      )}
      {state.loading ? null : (
        <div style={{ marginBottom: "20px" }} className="col-12">
          <Password
            old={state.gdata && state.gdata.password === null ? true : false}
            metod={load}
            isApp={isApp}
          />
        </div>
      )}
    </Fragment>
  );
}

export default Edite;
